var _desc, _g, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDuba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon dub\u0103") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Icon vectorial pentru dub\u0103, \xEEn stilul setului de referin\u021B\u0103.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5D2973"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 91,
    width: 46,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 112,
    width: 38,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 133,
    width: 53,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 154,
    width: 20,
    height: 9,
    rx: 4.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D313C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "     M62 72C62 64.8 67.8 59 75 59H178.7C188.2 59 197.3 62.8 204 69.6L229.8 95.8C240.2 106.4 246 120.6 246 135.4V145C246 153.3 239.3 160 231 160H75C67.8 160 62 154.2 62 147V72Z     M165 72H181.5C187.5 72 193.2 74.4 197.4 78.7L219 101H165V72Z     M111 77H154V119H111V77Z     M94 132H156V138H94V132Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D313C",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "     M121 161A25 25 0 1 1 71 161A25 25 0 1 1 121 161Z     M104 161A8 8 0 1 1 88 161A8 8 0 1 1 104 161Z     M229 161A25 25 0 1 1 179 161A25 25 0 1 1 229 161Z     M212 161A8 8 0 1 1 196 161A8 8 0 1 1 212 161Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 111,
    width: 10,
    height: 22,
    rx: 4,
    fill: "#5D2973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuba);
export default __webpack_public_path__ + "static/media/IconDuba.b7fd0d7ed3481aff7d87aa2bb1654eef.svg";
export { ForwardRef as ReactComponent };